import { ProviderStatus, providerColumns } from '../components';
import { ConditionalSharedCarrierStatus } from '../shared-carrier-status';
import { ConditionalPackingSlipProvider } from '../shared-packing-slips-status';
import { ProviderPropType } from '../types';
import { FulfillmentProviderActionsMenu } from './fulfillment-provider-actions-menu';

const NameComponent = ({ provider }) => {
  return provider.partnerName;
};

NameComponent.propTypes = {
  provider: ProviderPropType.isRequired,
};

const ProviderFactory = {
  [providerColumns.NAME]: NameComponent,
  [providerColumns.STATUS]: ProviderStatus,
  [providerColumns.SHARED_SERVICES]: ConditionalSharedCarrierStatus,
  [providerColumns.PACKING_SLIP_SHARING]: ConditionalPackingSlipProvider,
  [providerColumns.ACTIONS]: FulfillmentProviderActionsMenu,
};

export default ProviderFactory;
